/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */

import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Vocabulary, replacePlaceholders } from "../../Utils/Vocabulary";
import {
  isMobile,
  OrderStatus,
  // isMobile,
  OrderStatusType,
  // setFontColorBasedOnBackground,
} from "../../Utils/Utils";
import { StatusPanelType } from "../../Utils/Types";
import CustomizedStepper from "../CustomizedStepper";
import { Controller, useWatch } from "react-hook-form";
import GenericModal from "../GenericModal";
import SaveIcon from "@mui/icons-material/Save";
import genericStyles from "../../Styles/genericStyles.module.css";
import statusPanelStyles from "../../Styles/statusPanelStyles.module.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ro } from "date-fns/locale";
import { endpoints } from "../../Utils/UrlEnum";
import { postData } from "../../Services/postData";
import withRole from "../../Hooks/withRole";
import { OrderStatuses } from "../../Utils/Enums";

function StatusPanel(props: StatusPanelType) {
  ///const [anchorEl, setAnchorEl] = useState<any>(null);
  //const open = Boolean(anchorEl);
  const {
    control,
    reset,
    getValues,
    setTriggerReload,
    triggerReload,
    clientDocuments = [],
  } = props;
  const [statusArray, setStatusArray] = useState<any>([]);
  const [status, setStatus]: any = useState({
    id: "",
    name: "",
    color: "",
  });
  const [newStatus, setNewStatus]: any = useState({
    id: "",
    name: "",
    color: "",
  });

  const productName = useWatch({
    control,
    name: "product.name", // Watch product.name field
  });
  const passedPractical = useWatch({
    control,
    name: "passedOnFirstAttemptPractical",
  });
  const passedTheoretical = useWatch({
    control,
    name: "passedOnFirstAttemptTheoretical",
  });
  const [open, setOpen] = useState(false);
  const isCertificate = props.getValues("product")?.isCertificate;
  

  useEffect(() => {
    setStatus(getValues("status"));
  }, [getValues("status")]);

  //set statuses
  useEffect(() => {
    if (props.selectedOption) setStatus(props.selectedOption);
    let statuses = [];
    if (isCertificate !== undefined) {
      statuses = props?.allOptions?.filter(
        (status: any) =>
          status?.typeId?.name ==
          (isCertificate
            ? OrderStatusType.Certification
            : OrderStatusType.License),
      );
    }
    // Filter out excluded statuses based on role permissions
    if (props.excludedStatuses && props.excludedStatuses.length > 0) {
      statuses = statuses.filter(
        (status: any) => !props.excludedStatuses?.includes(status.name),
      );
    }
    setStatusArray(statuses);
  }, [productName]);

  // /**
  //  *
  //  * @param event
  //  */
  // const handleClick = (
  //   event: React.MouseEvent<HTMLButtonElement | HTMLDivElement, MouseEvent>
  // ) => {
  //   if (!anchorEl) setAnchorEl(event.currentTarget);
  // };

  // /**
  //  *
  //  * @param st
  //  */
  const handleChange = async (st?: any) => {
    if (st) {
      const passedField =
        st.name === OrderStatus.practical
          ? "passedOnFirstAttemptTheoretical"
          : st.name === OrderStatuses.FINALIZAT
          ? "passedOnFirstAttemptPractical"
          : undefined;

      props.handleChange(st, passedField);
      setStatus(st);
      setOpen(false);
      // check if should add new exam date
      if (
        st.name === OrderStatus.practical ||
        st.name == OrderStatus.theoretical
      ) {
        const model = {
          orderId: getValues("_id"),
          clientId: getValues("client_id._id"),
          type: st.name,
          examDate: getValues("examDate"),
        };
        const url = `${endpoints.exams.main}`;
        const res = (await postData(url, model)) as any;
        if (!res || res?.error) {
          return;
        }
        setTriggerReload(!triggerReload);
      }
    }
  };

  /**
   * Handle onClose event. Reset the form and new status, then close the modal.
   */
  const handleOnClose = () => {
    setOpen(false);
    setNewStatus({});
    reset({
      ...getValues(),
      passedOnFirstAttemptPractical: null,
      passedOnFirstAttemptTheoretical: null,
    });
  };

  const isExamStatus =
    newStatus?.name === OrderStatus.practical ||
    newStatus?.name === OrderStatus.theoretical;

  const isPassedToggleStatus =
    newStatus?.name === OrderStatus.practical ||
    newStatus?.name === OrderStatuses.FINALIZAT;

  const passedToggleField =
    newStatus?.name === OrderStatuses.FINALIZAT
      ? "passedOnFirstAttemptPractical"
      : "passedOnFirstAttemptTheoretical";

  const currentPassedValue =
    newStatus?.name === OrderStatuses.FINALIZAT
      ? passedPractical
      : passedTheoretical;

  const isSaveDisabled =
    isPassedToggleStatus && !isCertificate &&
    (currentPassedValue === null || currentPassedValue === undefined);

  const isFinalizat = newStatus?.name === OrderStatuses.FINALIZAT;

  const remainingAmount = isFinalizat
    ? parseFloat(getValues("product")?.price ?? "0") -
      parseFloat(getValues("amountPaid") ?? "0")
    : 0;

  const missingDocumentsCount = isFinalizat
    ? (() => {
        const requiredTypeIds: string[] =
          getValues("product")?.documentTypes || [];
        if (!requiredTypeIds.length) return 0;
        const existingTypeIds = clientDocuments.map(
          (doc: any) => (doc.documentTypeId as any)?._id || doc.documentTypeId
        );
        return requiredTypeIds.filter(
          (typeId) => !existingTypeIds.includes(typeId)
        ).length;
      })()
    : 0;

  const isFinalizatBlocked =
    isFinalizat && (remainingAmount > 0 || missingDocumentsCount > 0);

  const renderModalContent = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {`${Vocabulary.newStatus} ${newStatus?.name}`}
      </Grid>
      {isFinalizat && remainingAmount > 0 && (
        <Grid item xs={12}>
          <Alert severity="error">
            {replacePlaceholders(Vocabulary.finalizatBlockedUnpaid, {
              value: remainingAmount.toFixed(2),
            })}
          </Alert>
        </Grid>
      )}
      {isFinalizat && missingDocumentsCount > 0 && (
        <Grid item xs={12}>
          <Alert severity="error">
            {replacePlaceholders(Vocabulary.finalizatBlockedMissingDocuments, {
              value: missingDocumentsCount,
            })}
          </Alert>
        </Grid>
      )}
      {isExamStatus && (
        <Grid item xs={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ro}>
            <Controller
              control={control}
              name={"examDate"}
              render={({ field }) => (
                <DatePicker
                  label={
                    newStatus?.name === OrderStatus.practical
                      ? Vocabulary.practicalExamDate
                      : Vocabulary.theoreticalExamDate
                  }
                  value={field.value ? new Date(field.value) : null}
                  onChange={(newDate) => field.onChange(newDate)}
                  views={["month", "year", "day"]}
                  slots={{ textField: TextField }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      )}
      {isPassedToggleStatus && !isCertificate && (
        <Grid item xs={12}>
          <Controller
            control={control}
            name={passedToggleField}
            render={({ field }) => {
              const selected =
                field.value === true
                  ? "yes"
                  : field.value === false
                    ? "no"
                    : null;
              return (
                <Box className={statusPanelStyles.passedContainer}>
                  <Typography
                    variant="body1"
                    className={statusPanelStyles.passedQuestion}
                  >
                    {newStatus?.name === OrderStatuses.FINALIZAT
                      ? Vocabulary.passedPracticalExamOnFirstAttempt
                      : Vocabulary.passedTheoreticalExamOnFirstAttempt}
                  </Typography>
                  <Box className={statusPanelStyles.buttonGroup}>
                    <Button
                      variant={selected === "yes" ? "contained" : "outlined"}
                      color="success"
                      onClick={() => field.onChange(true)}
                      className={`${statusPanelStyles.passedButton} ${selected === "yes" ? statusPanelStyles.buttonYesSelected : ""}`}
                    >
                      {Vocabulary.yes}
                    </Button>
                    <Button
                      variant={selected === "no" ? "contained" : "outlined"}
                      color="error"
                      onClick={() => field.onChange(false)}
                      className={`${statusPanelStyles.passedButton} ${selected === "no" ? statusPanelStyles.buttonNoSelected : ""}`}
                    >
                      {Vocabulary.no}
                    </Button>
                  </Box>
                </Box>
              );
            }}
          />
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <Tooltip title={Vocabulary.pressTocChangeStatus} placement="top">
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //  backgroundColor: status?.color,
              width: "auto",
              cursor: "pointer",
              marginTop: "10px",
              overflowX: isMobile() ? "auto" : "visible",
              // boxShadow:
              //   "#4444 1px 1px 6px 1px inset, #4444 1px 1px 1px 1px inset",
              // // boxShadow: " rgba(0, 0, 0, 0.5) 0px 3px 12px",
              // padding: 10,

              //borderRadius: 5,
            }}
            // onClick={(e) => (props.disabled ? null : handleClick(e))}
          >
            {/* ✅ Fixed Stepper */}
            <CustomizedStepper
              selectedStep={status}
              stepsArray={statusArray}
              onStepChange={(step) => {
                setNewStatus(step);
                setOpen(true);
              }}
            />
          </div>
          <GenericModal
            open={open}
            title={Vocabulary.changeStatus}
            onClose={() => {
              handleOnClose();
            }}
            children={renderModalContent()}
            actions={
              <div className={genericStyles.modalActions}>
                <Button
                  color="error"
                  variant="outlined"
                  fullWidth
                  onClick={() => handleOnClose()}
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  fullWidth
                  onClick={() => handleChange(newStatus)}
                  variant="contained"
                  startIcon={<SaveIcon />}
                  disabled={isSaveDisabled || isFinalizatBlocked}
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
          />
        </>
      </Tooltip>
    </>
  );
}

export default withRole(StatusPanel);
